// extracted by mini-css-extract-plugin
export default {"container":"SendPointToUrbox_container__oZzFG"};